var isObject = require('./$.is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/core-js/library/modules/$.an-object.js
// module id = 327
// module chunks = 0